// ตัดคำลงท้ายสุภาพ (ครับ/ค่ะ/คะ/ค่า/คับ ...) ท้ายประโยคออกจากคำตอบของโมเดล (Qwen เล็กใช้ปนเพศ) — ให้พูดแบบเพื่อนสนิท
//  "นะคะ/นะครับ/นะค่ะ/นะคับ" -> "นะ" ; "ครับค่ะ/ค่ะครับ" ซ้อน -> ตัดทั้งคู่ ; ตัดเฉพาะที่อยู่ท้ายประโยคเท่านั้น
//  ท้ายประโยค = ตามด้วย จบข้อความ | ช่องว่าง/ขึ้นบรรทัด | . ! ? … , ; : | อัญประกาศ/ดอกจัน/วงเล็บปิด | อีโมจิ
const BOUND_CHARS = "\\s.!?…,，。;:\"'”’“*)\\]~";
const BOUND_FINAL = new RegExp(`(?=$|[${BOUND_CHARS}]|\\p{Extended_Pictographic})`, "u");
const BOUND_LIVE = new RegExp(`(?=[${BOUND_CHARS}]|\\p{Extended_Pictographic})`, "u"); // ระหว่าง stream: ท้ายสตริงยังไม่ใช่ขอบเขต
const PART = "(นะ)?(ครับผม|ครับค่ะ|ค่ะครับ|ครับ|คับ|ค่ะ|คะ|ค่า)";
const mk = (b) => new RegExp(PART + b.source, "gu");
const RE_FINAL = mk(BOUND_FINAL);
const RE_LIVE = mk(BOUND_LIVE);

// คำจริงที่ลงท้ายด้วยตัวอักษรเหล่านี้ (ห้ามตัด) เช่น มูลค่า คุณค่า สมค่า / ตึงคับ แน่นคับ
const GUARD = { "ค่า": /(มูล|คุณ|สม|ไร้|ราคา|ตีราคา|เสีย|ราคา)$/, "คับ": /(ตึง|แน่น|ขัด|อึดอัด|ฝืด)$/ };

function once(text, re) {
  return text.replace(re, (m, na, part, offset, str) => {
    if (!na && GUARD[part] && GUARD[part].test(str.slice(0, offset))) return m;
    if (na && GUARD[part] && GUARD[part].test(str.slice(0, offset + na.length))) return m;
    return na ? "นะ" : "";
  });
}

/**
 * final=true (ค่าเริ่มต้น): ข้อความสมบูรณ์ ท้ายสตริงนับเป็นท้ายประโยค + trim
 * final=false: ระหว่าง stream — ท้ายสตริงยังไม่ตัด (ยังไม่รู้ว่าจบคำ) และไม่ trim
 */
export function stripParticles(text, { final = true } = {}) {
  let s = String(text == null ? "" : text);
  const re = final ? RE_FINAL : RE_LIVE;
  for (let i = 0; i < 4; i++) {
    const next = once(s, re);
    if (next === s) break;
    s = next;
  }
  s = s.replace(/[ \t]+([.!?…,，。;:])/g, "$1").replace(/[ \t]+\n/g, "\n").replace(/[ \t]{2,}/g, " ");
  return final ? s.trim() : s;
}

/** จำนวนตัวอักษรท้ายที่ต้องบัฟเฟอร์ไว้ตอน stream (>= ยาวสุดของคำลงท้ายที่ตัดได้ "นะ"+"ครับค่ะ") */
export const HOLD_BACK = 9;

/** ข้อความที่ปลอดภัยจะแสดงระหว่าง stream: ตัดบัฟเฟอร์ท้ายไว้แล้วกรองส่วนที่เหลือ */
export const streamSafe = (raw) => stripParticles(String(raw).slice(0, Math.max(0, String(raw).length - HOLD_BACK)), { final: false });
